import { Dispatch, GetFrontOfficeState } from '@lumapps/redux/types';

import { actions } from './slice';

export const bypassNanny = () => (dispatch: Dispatch, getState: GetFrontOfficeState) => {
    const { saveCallback } = getState().nanny;
    dispatch(actions.hideNannyAlert());
    if (saveCallback) {
        saveCallback();
        // Unset the callback after use to avoid reusing it by mistake
        dispatch(actions.setSaveCallback(undefined));
    }
};

export const setNannySaveCallback = (callback: (() => void) | undefined) => (dispatch: Dispatch) => {
    dispatch(actions.setSaveCallback(callback));
};
